module.exports = __webpack_public_path__ + "assets/img/3f06-kp.svg";